module.exports = __webpack_public_path__ + "assets/1d92a624b5b9f862c8bc36b6f5be77f4.png";